<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ng-container *ngIf="!selectedOption; else filterOptionHeader">
      <ion-label data-cy="total-filters-selected-label">
        {{ 'i18n.notifications.filter' | translate }}
      </ion-label>
      <ion-badge
        *ngIf="totalFiltersSelected > 0"
        data-cy="total-filters-selected-badge"
      >
        {{ totalFiltersSelected }}
      </ion-badge>
    </ng-container>
    <ng-template #filterOptionHeader>
      <ion-buttons slot="start">
        <ion-button data-cy="back-modal-button" (click)="clearSelectedOption()">
          <ion-icon name="chevron-back" color="dark"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-label data-cy="filter-option-selected-number">
        {{ 'i18n.notifications.' + selectedOption | translate }}&nbsp;({{
          mobileSelectiions[selectedOption]?.length
        }})
      </ion-label>
    </ng-template>
  </ion-toolbar>
</ion-header>

<ion-content
  class="ion-content-modal-mobile"
  [class.is-customers]="selectedOption === 'customers'"
>
  <ng-container *ngIf="!selectedOption; else filterOptionsContent">
    <ion-item-divider></ion-item-divider>
    <ion-item
      *ngFor="let option of filterOptions"
      [attr.data-cy]="'notifications-filter-' + option + '-option'"
      detail
      (click)="setSelectedOption(option)"
    >
      <ion-label>
        {{ 'i18n.notifications.' + option | translate }}
        <span
          *ngIf="localFilters[option]?.length"
          data-cy="notifications-selected-number"
        >
          {{ 'i18n.notifications.selected' | translate }}:
          {{ localFilters[option]?.length }}
        </span>
      </ion-label>
    </ion-item>
  </ng-container>
  <ng-template #filterOptionsContent>
    <!-- Customers -->
    <ng-container *ngIf="selectedOption === 'customers'">
      <div class="searchbar-section" slot="fixed">
        <ion-searchbar
          data-cy="customers-searchbar"
          class="search"
          mode="md"
          placeholder="{{ 'i18n.common.searchCustomers' | translate }}"
          (ionBlur)="searchCustomer($event)"
          (ionClear)="clearCustomerSearch()"
          (search)="searchCustomer($event)"
        ></ion-searchbar>
      </div>
      <div
        *ngIf="!searchedCustomers?.length"
        class="no-customers-found"
        data-cy="no-customers-found-text"
      >
        <p>{{ 'i18n.notifications.noCustomersFound' | translate }}</p>
      </div>
      <ion-list *ngIf="searchedCustomers?.length" class="customers-list">
        <ion-item-divider></ion-item-divider>
        <ion-item *ngFor="let customer of searchedCustomers">
          <ion-badge
            slot="start"
            [attr.data-cy]="
              'searched-customer-' + customer.customerNumber + '-badge'
            "
          >
            {{ customer.customerName[0] }}
          </ion-badge>
          <ion-label
            id="customer-number"
            [attr.data-cy]="
              'searched-customer-' +
              customer.customerNumber +
              '-name-number-label'
            "
          >
            {{ customer.customerName | titlecase }}&nbsp;({{
              customer.customerNumber
            }})
            <span> {{ customer.city | titlecase }}, {{ customer.state }} </span>
          </ion-label>
          <ion-checkbox
            aria-labelledby="customer-number"
            mode="ios"
            slot="end"
            [attr.data-cy]="
              'notification-custumer-' + customer.customerNumber + '-option'
            "
            [checked]="isCustomerChecked(customer.customerNumber)"
            (ionChange)="updateCustomersSelected(customer.customerNumber)"
          >
          </ion-checkbox>
        </ion-item>
      </ion-list>
    </ng-container>
    <!-- Alert Types -->
    <ion-list *ngIf="selectedOption === 'alertTypes'">
      <ion-item-divider></ion-item-divider>
      <ion-item *ngFor="let alertType of alertTypes">
        <ion-label id="alert-type">
          {{ 'i18n.notifications.alertType' + alertType | translate }}
        </ion-label>
        <ion-checkbox
          aria-labelledby="alert-type"
          [attr.data-cy]="'notification-alertType-' + alertType + '-option'"
          mode="ios"
          slot="end"
          [checked]="isAlertTypeChecked(alertType)"
          (ionChange)="updateAlertTypesSelected(alertType)"
        >
        </ion-checkbox>
      </ion-item>
    </ion-list>
    <!-- Statuses -->
    <ion-list *ngIf="selectedOption === 'statuses'">
      <ion-item-divider></ion-item-divider>
      <ion-item *ngFor="let status of statuses">
        <ion-label id="status">
          {{ 'i18n.notifications.status' + status | translate }}
        </ion-label>
        <ion-checkbox
          aria-labelledby="status"
          [attr.data-cy]="'notification-status-' + status + '-option'"
          mode="ios"
          slot="end"
          [checked]="isStatusChecked('Read' === status)"
          (ionChange)="updateStatusSelected('Read' === status)"
        >
        </ion-checkbox>
      </ion-item>
    </ion-list>
  </ng-template>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="clear-all-modal-button"
        class="usf-outline-green-mobile-modal-button"
        (click)="clearAll()"
      >
        {{ 'i18n.common.clearAll' | translate }}
      </ion-button>
      <ion-button
        *ngIf="!selectedOption"
        data-cy="apply-modal-button"
        class="usf-fill-green-mobile-modal-button"
        (click)="apply()"
      >
        {{ 'i18n.common.apply' | translate }}
      </ion-button>
      <ion-button
        *ngIf="selectedOption"
        class="usf-fill-green-mobile-modal-button"
        (click)="saveMobileFilters()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
